import _ from "lodash";
import Indicador from "..";
import EditFields from "./components/EditFields";
import { ParamFields } from "./components/ParamFields";
import ReportSummary from "./reports/summary";
import apontamentoReport from "./reports/index";

export default class AVL extends Indicador {
    static get fullName() {
        return "Aferição de Vinhaça Localizada";
    }

    static get abbrev() {
        return "AVL";
    }
    static get field() {
        return "avl";
    }

    static paramFields(tipoIndicadorField = '') {
        return <ParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <EditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return apontamentoReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return ReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        const total = apontamento.coletas.length;
        let sumPesagem = 0;
        let sumMLA = 0;

        for (const coleta of apontamento.coletas) {
            if (coleta.pesagem) {
                sumPesagem += f(coleta.pesagem);
            }
            if (coleta.metrosLinearesAmostra) {
                sumMLA += f(coleta.metrosLinearesAmostra);
            }
        }

        apontamento.media = sumPesagem / total;
        apontamento.media = apontamento.media.toFixed(4);
        apontamento.mediaMetrosLinearesAmostra = sumMLA / total;
        apontamento.mediaMetrosLinearesAmostra = apontamento.mediaMetrosLinearesAmostra.toFixed(4);

        // Dose por metro linear média das coletas.
        apontamento.doseMetro = apontamento.media / f(apontamento.mediaMetrosLinearesAmostra);
        apontamento.doseMetro = apontamento.doseMetro.toFixed(4);

        apontamento.afericao = apontamento.doseMetro * f(params.metrosLinearesHectare);
        apontamento.afericao = apontamento.afericao.toFixed(4);

        const dosagemRecomendada = f(apontamento.dosagemRecomendada);

        if (!_.isNaN(dosagemRecomendada)) {
            const rawConformidade = (apontamento.afericao / f(apontamento.dosagemRecomendada)) * 100;
            apontamento.acima = rawConformidade > f(params.intervaloMax) ? 1 : 0;
            apontamento.abaixo = rawConformidade < f(params.intervaloMin) ? 1 : 0;
            let conformidade = rawConformidade > 100 ? rawConformidade - 200 : rawConformidade;

            return Math.abs(conformidade).toFixed(2);
        } else {
            apontamento.acima = 0;
            apontamento.abaixo = 0;
            return 0;
        }
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 94.73, 100, 103.15);
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            { title: "Variedade", field: "insumo", width: 'auto' },
            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },

            {
                title: "Aferição", width: 'auto', getValue: (a) => {
                    if (a.afericao) {
                        return parseFloat(a.afericao).toFixed(2)
                    }
                    return '0'
                }
            },
            {
                title: "Média", width: 'auto', getValue: (a) => {
                    if (a.media) {
                        return parseFloat(a.media).toFixed(2)
                    }
                    return '0'
                }
            },
            {
                title: "Dose/M", width: 'auto', getValue: (a) => {
                    if (a.doseMetro) {
                        return parseFloat(a.doseMetro).toFixed(2)
                    }
                    return '0'
                }
            },

            {
                title: "Conf.(%)", field: "conformidade", width: "auto", getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }

    static getResultStr(apontamento) {
        let media = parseFloat(apontamento.media).toFixed(2)
        let doseMetro = parseFloat(apontamento.doseMetro).toFixed(2)
        let afericao = parseFloat(apontamento.afericao).toFixed(2)

        return "Media: " + media +
            ", Dose/M: " + doseMetro +
            " e Aferição: " + afericao
    }
}
